import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import TextField from '../common/Input';
import Button from '../common/Button';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const GreenCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#43a047',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const CreateNewsLetter = (props) => {
  const { classes } = props;
  const [state, setState] = useState({
    users: true,
    chefs: false,
    restaurants: false,
  });
  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (<div>
    <Card className={classes.root}>
      <CardHeader subheader="Create Newsletter" classes={ { subheader: classes.header }}/>
      <CardContent>
        <TextField
          label="Title of Newsletter"
          placeholder="Title"          
        />
        <div className={classes.description}>
        <InputLabel shrink={true}> Description </InputLabel>
        <TextareaAutosize
            className={classes.description}
            rowsMin={10}
            aria-label="maximum height"
            placeholder="Write here..."
          />
        </div>

        <div className={classes.users}>
          <InputLabel shrink={true}> Send to Users </InputLabel>
          <FormControlLabel
            classes={{ label: classes.label }}
            control={<GreenCheckbox checked={state.users} onChange={handleChange} name="users" />}
            label="Users"
          />
          <FormControlLabel
             classes={{ label: classes.label }}  
            control={<GreenCheckbox checked={state.chefs} onChange={handleChange} name="chefs" />}
            label="Chefs"
          />
          <FormControlLabel
            classes={{ label: classes.label }}
            control={<GreenCheckbox checked={state.restaurants} onChange={handleChange} name="restaurants" />}
            label="Restaurants"
          />
        </div>
        <Button size="small" label="Send" onClick={()=> console.log("CLicked")}></Button>      
      </CardContent>
    </Card>
  </div>)
}

export default CreateNewsLetter;
